// extracted by mini-css-extract-plugin
module.exports = {"report_content":"reportLayer_report_content__1Bs6U","button":"reportLayer_button__3zmmB","table_content":"reportLayer_table_content__3Tl9v","paging":"reportLayer_paging__oszjy"};